// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5a4a59c0","732":"000e4286","977":"b309556f"}[chunkId] + ".chunk.js";
};